module.exports = __webpack_public_path__ + "static/media/icon_electricidad.9efd4a79.svg";